import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
// import { VN as VNFlag } from 'country-flag-icons/react/3x2';
import { useRouter } from 'next/router';
import React from 'react';

export const BarWrapperDiv = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  background: ${style.color.white4};
  position:relative;
`;
const HeaderWrapperDiv = styled(BarWrapperDiv)`
  box-shadow: 1px -5px 10px;
  margin-bottom: 2px;
`;

const StyledDiv = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledHeader = styled(StyledDiv)`
  padding: ${pr`3px`} ${pr`16px`};
  flex-wrap: wrap;
  width: ${pr`1152px`};
`;

const HeaderBar = () => {
  const router = useRouter();
  return (
    <HeaderWrapperDiv>
      <StyledHeader>
        <StyledDiv>
          <Button onClick={() => { router.push('/'); }}>
            <img
              src={process.env.NEXT_PUBLIC_LOGO_LINK}
              alt="logo"
              className="lazyload"
              style={{
                height: pr`50px`,
              }}
            />
          </Button>
        </StyledDiv>

      </StyledHeader>
    </HeaderWrapperDiv>
  );
};

export default HeaderBar;
